import config from '@/config'
import authService from '@/services/authService'

const backendUrl = config.backendUrl || ''

// Calls that already have their own "not logged in yet" handling (the
// router guard's initial auth check) — a 401 here is expected and must NOT
// trigger a hard redirect, or it would fight with that existing SPA flow.
const EXCLUDED_PATTERNS = ['/api/auth/', '/api/users/me']

let redirecting = false

function requestUrl(input) {
  if (typeof input === 'string') return input
  if (input instanceof Request) return input.url
  return input?.url || ''
}

function handleSessionExpired() {
  if (redirecting) return
  const current = window.location.pathname + window.location.search
  if (current.startsWith('/login')) return
  redirecting = true
  authService.logout()
  window.location.href = `/login?redirect=${encodeURIComponent(current)}`
}

/**
 * The Google access token backing a session expires ~1h after login (see
 * src/core/providers.py — every authenticated request re-validates it live
 * against Google, with no refresh-token flow yet), so any action can
 * suddenly 401 mid-session. Without this, each component would need to
 * handle that raw "Google token validation failed" string on its own —
 * instead, catch it once here and send the user back to /login.
 */
export function installAuthInterceptor() {
  const originalFetch = window.fetch.bind(window)

  window.fetch = async (...args) => {
    const response = await originalFetch(...args)

    const url = requestUrl(args[0])
    const isOwnBackend = url.startsWith(backendUrl)
    const isExcluded = EXCLUDED_PATTERNS.some((p) => url.includes(p))

    if (response.status === 401 && isOwnBackend && !isExcluded) {
      handleSessionExpired()
      // A navegação pro /login já está a caminho — não deixa quem chamou
      // seguir em frente com um 401 pela metade (evita mostrar o erro cru
      // por uma fração de segundo antes do redirect acontecer de verdade).
      return new Promise(() => {})
    }

    return response
  }
}
